import { render, staticRenderFns } from "./EnquireDispatchForm.vue?vue&type=template&id=365a56ec"
import script from "./EnquireDispatchForm.vue?vue&type=script&lang=ts"
export * from "./EnquireDispatchForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports